import { Modal } from 'antd';
import { React } from 'react';

const ConfirmAttributesModal = ({
  open,
  onConfirm,
  onCancel,
  addedCount,
  removedCount,
  isLoading,
}) => {
  const getConfirmMessage = () => {
    if (addedCount > 0 && removedCount > 0) {
      return `Voulez-vous vraiment ajouter ${addedCount} attribut(s) et supprimer ${removedCount} attribut(s) ?`;
    } else if (addedCount > 0) {
      return `Voulez-vous vraiment ajouter ${addedCount} attribut(s) ?`;
    } else {
      return `Voulez-vous vraiment supprimer ${removedCount} attribut(s) ?`;
    }
  };

  return (
    <Modal
      title="Confirmer les modifications"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Confirmer"
      cancelText="Annuler"
      confirmLoading={isLoading}
      okButtonProps={{
        disabled: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <p>{getConfirmMessage()}</p>
    </Modal>
  );
};

export default ConfirmAttributesModal;
